export default __webpack_public_path__ + "static/media/O-143.4409d16d.png";